export default {
      id: "common__resend_sm-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__resend_sm",
      toString: function () {
        return this.url;
      }
    }